import script from "./AppSocials.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSocials.vue?vue&type=script&setup=true&lang=ts"

import "./AppSocials.vue?vue&type=style&index=0&id=4a7c64d4&lang=scss"

const __exports__ = script;

export default __exports__